// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"708":"196f2440","771":"2ecf889c","6155":"35d46e80","7371":"2ecf889c","8323":"196f2440","8986":"ea3db241","9497":"d2002f34"}[chunkId] + ".chunk.css";
};